import { Button } from '@/components/Button/Button'
import { Loader } from '@/components/Loader/Loader'
import { Popup } from '@/components/Popup/Popup'
import { GeneratorFormContext } from '@/hooks/useGeneratorForm'
import { useToneState } from '@/state/tones'
import type { FunctionalComponent } from 'preact'
import { useContext, useState } from 'preact/hooks'
import { useShallow } from 'zustand/shallow'

export const DeleteTone: FunctionalComponent<{
  onCancel: () => void
  onSuccess: () => void
}> = props => {
  const form = useContext(GeneratorFormContext)!

  const toneStore = useToneState(useShallow(
    s => s.list.find(item => item.id === form.toneId),
  ))

  const [tone] = useState(toneStore)

  const deleteTone = useToneState(s => s.delete)

  const [loading, setLoading] = useState(false)

  return (
    <>
      <Popup.Title>
        {tone?.defaultToneId !== null
          ? `Reset ${tone?.name ?? 'unknown'}`
          : `Delete ${tone?.name ?? 'unknown'}`}
      </Popup.Title>

      <Popup.Fields>
        <Popup.Msg>
          {tone?.defaultToneId !== null
            ? 'Your customizations will be removed and the default tone will be restored.'
            : 'This tone will be permanently deleted.'}
        </Popup.Msg>
      </Popup.Fields>

      <Popup.Footer>
        <div />
        <Popup.Buttons>
          <Button
            onClick={props.onCancel}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            disabled={loading}
            onClick={async () => {
              try {
                setLoading(true)
                if (!tone?.id) throw new Error('Tone must be defined')
                await deleteTone(tone.id)
                form.setToneId(null)
                props.onSuccess()
              }
              catch (e) {
                console.error(e)
              }
              finally {
                setLoading(false)
              }
            }}
          >
            {tone?.defaultToneId !== null ? 'Reset' : 'Delete'}
            {loading && (
              <>
                {' '}
                <Loader />
              </>
            )}
          </Button>
        </Popup.Buttons>
      </Popup.Footer>
    </>
  )
}
